import { Button, Popover, PopoverBody, PopoverContent, PopoverTrigger } from "@biblioteksentralen/react";
import { capitalize } from "radash";
import { ChevronDown } from "react-feather";
import FilterOptions from "./FilterOptions";
import { Filteredtems } from "./getFilteredItems";
import { Filter, FilterableItem } from "./useFilter";

interface Props<T extends FilterableItem> {
  filter: Filter<T>;
  filteredItems: Filteredtems<T>;
}

const FilterMenu = <T extends FilterableItem>({ filter, filteredItems }: Props<T>) => (
  <Popover placement="bottom-start">
    <PopoverTrigger>
      <Button size="md" variant="outline" rightIcon={<ChevronDown />}>
        {filter.label || capitalize(filter.key)}
      </Button>
    </PopoverTrigger>
    <PopoverContent width="12rem">
      <PopoverBody>
        <FilterOptions filter={filter} filteredItems={filteredItems} />
      </PopoverBody>
    </PopoverContent>
  </Popover>
);

export default FilterMenu;
